import * as logosBlack from '../../assets/logo-black';
import * as logosWhite from '../../assets/logo-white';

export const iconsWhite = {
  amazon: logosWhite.AmazonIcon,
  apple: logosWhite.AppleIcon,
  bitbucket: logosWhite.BitbucketIcon,
  coinbase: logosWhite.CoinbaseIcon,
  discord: logosWhite.DiscordIcon,
  facebook: logosWhite.FacebookIcon,
  figma: logosWhite.FigmaIcon,
  github: logosWhite.GithubIcon,
  gitlab: logosWhite.GitlabIcon,
  google: logosWhite.GoogleIcon,
  linkedin: logosWhite.LinkedinIcon,
  microsoft: logosWhite.MicrosoftIcon,
  salesforce: logosWhite.SalesforceIcon,
  slack: logosWhite.SlackIcon,
  snapchat: logosWhite.SnapchatIcon,
  tiktok: logosWhite.TiktokIcon,
  twitch: logosWhite.TwitchIcon,
  xTwitter: logosWhite.XTwitterIcon,
  yahoo: logosWhite.YahooIcon,
  phantom: logosWhite.PhantomIcon,
  metamask: logosWhite.MetamaskIcon,
  binance: logosWhite.BinanceIcon,
  gmail: logosWhite.GmailIcon,
  outlook: logosWhite.OutlookIcon,
};

export const iconsBlack = {
  amazon: logosBlack.AmazonIcon,
  apple: logosBlack.AppleIcon,
  bitbucket: logosBlack.BitbucketIcon,
  coinbase: logosBlack.CoinbaseIcon,
  discord: logosBlack.DiscordIcon,
  facebook: logosBlack.FacebookIcon,
  figma: logosBlack.FigmaIcon,
  github: logosBlack.GithubIcon,
  gitlab: logosBlack.GitlabIcon,
  google: logosBlack.GoogleIcon,
  linkedin: logosBlack.LinkedinIcon,
  microsoft: logosBlack.MicrosoftIcon,
  salesforce: logosBlack.SalesforceIcon,
  slack: logosBlack.SlackIcon,
  snapchat: logosBlack.SnapchatIcon,
  tiktok: logosBlack.TiktokIcon,
  twitch: logosBlack.TwitchIcon,
  xTwitter: logosBlack.XTwitterIcon,
  yahoo: logosBlack.YahooIcon,
  phantom: logosBlack.PhantomIcon,
  metamask: logosBlack.MetamaskIcon,
  binance: logosBlack.BinanceIcon,
  gmail: logosBlack.GmailIcon,
  outlook: logosBlack.OutlookIcon,
};
